module.exports = __webpack_public_path__ + "img/check-icon.b73ae39e.svg";